import React from 'react';
import HeartIcon from '../icons/heartIcon';
import './matchedAmount.scss';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const MatchedAmount = (props) => {
    return (
        <div>
            {props.matchValue > 0 ? (<div style={{ display:'flex', padding:'0 20px 8px', alignItems:'center' }}>
            <HeartIcon src={`${config.cdnUrl}/static/icons/checkout/total-impact.svg`} /> <span style={{marginLeft:'5px'}}>Matched {props.matchValue}% by us</span>
            </div>) : null}
        </div>

    )
};

export default MatchedAmount
